/**
 * Whether or not the view port of the browser window is mobile.
 *
 * @returns {boolean} true if it is, false if not
 */
const isMobile = () => {
    return document.documentElement.clientWidth <= 990;
  };
  
  /**
   * TIMELINE: Initializes the timeline section component
   */
  const initializeTimeline = () => {
    // Pointer to timeline items
    const timeline = document.querySelectorAll('main > .timeline-item');
    if (timeline?.length > 0) {
      // Loops trough all timeline items/shoes
      timeline.forEach((item) => {
        // Adds click event
        item.addEventListener('click', () => {
  
          // 1 - Remove any exsiting iterations
          document.getElementById('timeline-item__iterations')?.remove();
  
          // 2 - Clones the clicked item iteration
          const timelineIterations = item.querySelector('template').content.cloneNode(true);        
  
          // 3 - Adds the new iteration and displays it
          item.parentNode.appendChild(timelineIterations);
          
          // 4 - Click event for close button
          document.getElementById('timeline-item__iterations__close')?.addEventListener('click', () => {
            // Reenables body scroll
            document.body.style.overflow = '';
            document.getElementById('timeline-item__iterations')?.remove();
          });
  
          // 5 - Initializes carousels for each section
          document.querySelectorAll('.timeline-item__iterations__carousel__slides')?.forEach((carousel) => {
            $(carousel).slick({
              dots: true,
              arrows: true,
              infinite: true,
              lazyLoad: 'ondemand'
            });
          });
  
          // 6 - Scrolls the view into the section
          if (!isMobile()){
            window.scroll({
              behavior: 'smooth',
              top: document.getElementById('timeline-item__iterations').offsetTop
            });
            setTimeout(() => {
              document.getElementById('timeline-item__iterations')?.querySelector('.slick-next')?.focus();
            }, 500);     
          } else {
            // 7 - Disables browser scroll
            document.body.style.overflow = 'hidden';
            document.getElementById('timeline-item__iterations__close')?.focus();
          }
  
          setTimeout(() => {
            document.getElementById('timeline-item__iterations')?.classList.add("open");
          }, 50);
        });
      });
    }
  }

  window.addEventListener('load', initializeTimeline);
  
  // Takes care of handling any mobile to desktop (and vice versa) styles
  window.addEventListener('resize', (() => {
    let timeout;  
    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (!isMobile() && !document.body.classList.contains('overflow-hidden-desktop')) {
          // Reenables body scroll
          document.body.style.overflow = 'hidden auto';
        }
      }, 250);
    };
  })());
  